'use client';
import React from 'react';
import { useParams } from 'next/navigation';
import { Link as SharedLink } from '@launchstore/shared-puck';
import type { LinkProps } from '@launchstore/shared-puck';

/**
 * Storefront Link wrapper — prefixes internal href URLs with the country
 * code so links resolve on the /[countryCode]/... route structure.
 *
 * The template stores clean URLs (e.g. /pages/about-us); this wrapper
 * transforms them to /{countryCode}/pages/about-us at render time.
 * External URLs (http://, https://, mailto:, tel:) and hash anchors (#)
 * are passed through unchanged.
 */
const SharedLinkRender = (SharedLink as any).render;

const withCountryCode = (href: string, countryCode: string): string => {
  if (!href) return href;
  if (/^(https?:|mailto:|tel:|#)/.test(href)) return href;
  if (href.startsWith(`/${countryCode}/`)) return href;
  const cleanPath = href.startsWith('/') ? href : `/${href}`;
  return `/${countryCode}${cleanPath}`;
};

export const Link: any = {
  ...SharedLink,
  render: (props: any) => {
    const params = useParams();
    const countryCode = (params?.countryCode as string) || 'us';
    return <SharedLinkRender {...props} href={withCountryCode(props.href, countryCode)} />;
  },
};

export type { LinkProps };
export default Link;
